module.exports = __webpack_public_path__ + "img/20190722165028.23c265e5.jpg";